import React from "react";

export const PerformerAgreement = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Соглашение с Исполнителем</h2>
          <p className="text-sm text-gray-500">для самозанятых фотографов/видеографов платформы "Реверсия"</p>
          <p className="text-xs text-gray-400 mt-2">Обновлено: {new Date().toLocaleDateString('ru-RU')}</p>
        </div>
        
        <div className="prose max-w-none text-gray-700 space-y-6">
          
          {/* 1. Общие положения */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">1. Общие положения</h3>
            
            <div className="space-y-3">
              <p>
                <strong>1.1.</strong> Исполнитель — физическое лицо, оказывающее услуги фото-/видеосъемки 
                через цифровую платформу "Реверсия" (reversia.ru).
              </p>
              
              <div className="bg-blue-50 p-4 rounded-lg">
                <p><strong>1.2.</strong> Настоящее Соглашение является приложением к:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li><strong>Публичной оферте Reversia</strong> - основные условия сотрудничества</li>
                  <li><strong>Политике конфиденциальности</strong> - обработка персональных данных</li>
                  <li><strong>Правилам платформы</strong> - процедуры и стандарты качества</li>
                </ul>
              </div>
              
              <div className="bg-yellow-50 p-4 rounded border-l-4 border-yellow-400">
                <p><strong>1.3.</strong> Для специальных услуг действуют дополнительные условия:</p>
                
                <div className="mt-3 space-y-3">
                  <div className="bg-white p-3 rounded">
                    <h4 className="font-semibold text-purple-800">«Тайный покупатель»:</h4>
                    <ul className="list-disc list-inside text-sm mt-1">
                      <li>Запрещено раскрывать личность клиенту</li>
                      <li>Отчеты проверяются по геометке и timestamp</li>
                      <li><strong>Комиссия платформы: 15-25%</strong></li>
                    </ul>
                  </div>
                  
                  <div className="bg-white p-3 rounded">
                    <h4 className="font-semibold text-green-800">«Мобильный корреспондент»:</h4>
                    <ul className="list-disc list-inside text-sm mt-1">
                      <li>Обязательное качество видео: 4K (3840×2160)</li>
                      <li>Фиксация геометок в приложении Reversia</li>
                      <li>Запрещено передавать задание субподрядчикам</li>
                      <li><strong>Комиссия платформы: 15-25%</strong></li>
                    </ul>
                  </div>
                  
                  <div className="bg-white p-3 rounded">
                    <h4 className="font-semibold text-blue-800">«Уход за захоронениями»:</h4>
                    <ul className="list-disc list-inside text-sm mt-1">
                      <li>Обязателен фотоотчет с геоданными</li>
                      <li>Запрещено передавать услугу субподрядчикам без уведомления Администрации</li>
                      <li><strong>Комиссия платформы: 15-25%</strong></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 2. Обязанности Исполнителя */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">2. Обязанности Исполнителя</h3>
            
            <div className="space-y-4">
              <div className="bg-red-50 p-4 rounded">
                <h4 className="font-semibold text-red-800 mb-2">2.1. Правовые требования</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Самостоятельно проверять разрешение на съемку в выбранной локации</li>
                  <li>Не проводить съемку в запрещенных зонах (см. Приложение 1)</li>
                  <li>Возмещать ущерб за нарушения законодательства РФ</li>
                  <li>Соблюдать требования ст. 152.1 ГК РФ (согласие на съемку лиц)</li>
                </ul>
              </div>
              
              <div className="bg-green-50 p-4 rounded">
                <h4 className="font-semibold text-green-800 mb-2">2.2. Технические требования</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li><strong>Дроны:</strong> запрещены в городах без специального разрешения</li>
                  <li><strong>Профессиональная аппаратура:</strong> уведомлять клиента о необходимости разрешений</li>
                  <li><strong>Геовалидация:</strong> использование через Yandex Maps API обязательно</li>
                  <li><strong>Статус заказа:</strong> своевременное обновление в приложении</li>
                </ul>
              </div>
              
              <div className="bg-orange-50 p-4 rounded border-l-4 border-orange-400">
                <h4 className="font-semibold text-orange-800 mb-2">2.3. Запрет субподряда</h4>
                <p className="text-sm">
                  <strong>2.3.1.</strong> Исполнитель не вправе передавать заказы третьим лицам без 
                  письменного согласия Администрации. Нарушение влечет немедленное расторжение соглашения 
                  и возмещение убытков заказчика.
                </p>
              </div>

              <div className="bg-blue-50 p-4 rounded border-l-4 border-blue-400">
                <h4 className="font-semibold text-blue-900 mb-2">2.4. Верификация личности</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li><strong>2.4.1.</strong> Исполнитель вправе добровольно пройти верификацию личности по паспорту через раздел «Верификация личности» в личном кабинете.</li>
                  <li><strong>2.4.2.</strong> Для заданий с доступом к жилым помещениям, дачным участкам, личным вещам и документам Заказчика (подкатегории «Общих услуг»: ремонт и сборка, уборка, курьер и доставка, грузчик и переезд, присмотр за питомцем, личное поручение), а также для услуг «Уход за захоронениями» отклик доступен только Исполнителям с подтверждённой личностью.</li>
                  <li><strong>2.4.3.</strong> Заявка рассматривается Администрацией вручную. Исполнитель обязуется предоставлять достоверные данные; предоставление чужих или поддельных документов влечёт блокировку аккаунта.</li>
                  <li><strong>2.4.4.</strong> Обработка и сроки хранения данных верификации определены Политикой конфиденциальности (п. 3.1). Фотографии документов хранятся в зашифрованном виде и удаляются через 30 дней после решения по заявке.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 3. Финансовые условия - ИСПРАВЛЕННЫЕ */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">3. Финансовые условия</h3>
            
            <div className="bg-gray-50 p-4 rounded">
              <h4 className="font-semibold mb-3">3.1. Структура комиссий</h4>
              
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">Тип услуг</th>
                      <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">Ставка комиссии</th>
                      <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">Условия</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="bg-green-50">
                      <td className="px-4 py-3 font-medium">Стандартные услуги</td>
                      <td className="px-4 py-3 font-semibold text-green-700">10%</td>
                      <td className="px-4 py-3">Базовая ставка, акции от 5%</td>
                    </tr>
                    <tr className="bg-yellow-50">
                      <td className="px-4 py-3 font-medium">«Тайный покупатель»</td>
                      <td className="px-4 py-3 font-semibold text-yellow-700">15%</td>
                      <td className="px-4 py-3">Требуется детальный отчет</td>
                    </tr>
                    <tr className="bg-blue-50">
                      <td className="px-4 py-3 font-medium">«Мобильный корреспондент»</td>
                      <td className="px-4 py-3 font-semibold text-blue-700">25%</td>
                      <td className="px-4 py-3">4K видео + геометки + портфолио</td>
                    </tr>
                    <tr className="bg-purple-50">
                      <td className="px-4 py-3 font-medium">«Уход за захоронениями»</td>
                      <td className="px-4 py-3 font-semibold text-purple-700">15%</td>
                      <td className="px-4 py-3">Фотоотчет с геометками</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div className="mt-4 bg-blue-50 p-4 rounded">
              <h4 className="font-semibold text-blue-800 mb-2">3.2. Система выплат исполнителям:</h4>
              <div className="bg-blue-50 p-3 rounded mb-3">
                <p className="text-sm text-blue-800 font-medium mb-2">
                  <strong>Режимы выплат:</strong> Администрация имеет право переключать систему выплат между автоматическим и ручным режимами.
                </p>
              </div>
              
              <div className="space-y-4">
                <div>
                  <h5 className="font-semibold text-green-700 mb-2"> Автоматический режим (основной):</h5>
                  <ul className="list-disc list-inside text-sm space-y-1 ml-4">
                    <li><strong>Способ выплат:</strong> Через систему YuKassa на банковские карты, счета или YooMoney кошельки</li>
                    <li><strong>Комиссия YuKassa:</strong> 2,8% + 30₽ за выплату на карту, 2,8% на YooMoney кошелек</li>
                    <li><strong>Лимиты выплат:</strong> От 5₽ до 500,000₽ за одну операцию, до 600,000₽ в месяц на одного исполнителя</li>
                    <li><strong>Сроки выплат:</strong> Мгновенно на карты и YooMoney, в течение нескольких часов на банковские счета</li>
                    <li><strong>Автоматические фискальные чеки:</strong> YuKassa + НПД формируют чеки за комиссию платформы для ИП (230808284051)</li>
                    <li><strong>Документооборот:</strong> Ежедневные отчеты о выплатах и ежемесячные справки</li>
                  </ul>
                </div>
                
                <div>
                  <h5 className="font-semibold text-orange-700 mb-2">Ручной режим (резервный):</h5>
                  <ul className="list-disc list-inside text-sm space-y-1 ml-4">
                    <li><strong>Способ выплат:</strong> Банковские переводы или СБП по реквизитам исполнителя</li>
                    <li><strong>Сроки выплат:</strong> 1-3 рабочих дня после подтверждения администратором</li>
                    <li><strong>Применение:</strong> Форс-мажорные ситуации, технические сбои, спорные ситуации</li>
                    <li><strong>Уведомления:</strong> Исполнители уведомляются о переключении в ручной режим</li>
                  </ul>
                </div>
                
                <div className="bg-yellow-50 p-3 rounded">
                  <p className="text-sm text-yellow-800">
                    <strong>Итоговая сумма:</strong> Исполнитель получает 75-90% от стоимости заказа (за вычетом комиссии платформы) 
                    независимо от режима выплат.
                  </p>
                </div>
              </div>
              
              <div className="mt-3 p-2 bg-yellow-50 rounded text-xs">
                <p><strong>Важно:</strong> Все изменения цены требуют письменного согласия в чате задания. История изменений доступна в личном кабинете исполнителя.</p>
              </div>
            </div>
          </div>

          {/* Приложение 1 - Запрещенные локации */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Приложение 1: Запрещенные и ограниченные локации</h3>
            
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-red-50 p-4 rounded border-l-4 border-red-500">
                <h4 className="font-semibold text-red-800 mb-2">Полностью запрещены:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Военные объекты и части</li>
                  <li>Пограничные зоны</li>
                  <li>Атомные электростанции (АЭС)</li>
                  <li>Объекты государственной безопасности</li>
                  <li>Режимные предприятия</li>
                </ul>
              </div>
              
              <div className="bg-yellow-50 p-4 rounded border-l-4 border-yellow-400">
                <h4 className="font-semibold text-yellow-800 mb-2">Требуется согласование:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Торговые центры и магазины</li>
                  <li>Аэропорты и вокзалы</li>
                  <li>Частные территории</li>
                  <li>Кладбища (письменное разрешение)</li>
                  <li>Объекты культурного наследия</li>
                </ul>
              </div>
            </div>
            
            <div className="mt-4 bg-gray-100 p-4 rounded">
              <h4 className="font-semibold mb-2">Особые условия для спецуслуг:</h4>
              <div className="grid md:grid-cols-3 gap-4 text-sm">
                <div>
                  <strong>«Тайный покупатель»:</strong>
                  <p>Запрещено делать фото/видео без согласия объекта проверки</p>
                </div>
                <div>
                  <strong>«Мобильный корреспондент»:</strong>
                  <p>Обязательно получение разрешения на съемку в публичных местах с людьми</p>
                </div>
                <div>
                  <strong>«Уход за захоронениями»:</strong>
                  <p>Письменное разрешение от владельца участка или администрации кладбища</p>
                </div>
              </div>
            </div>
          </div>

          {/* Контактная информация */}
          <div className="border-t pt-4">
            <h4 className="font-semibold mb-2">Контакты для вопросов по соглашению:</h4>
            <p className="text-sm">
              Email: <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline">support@reversia.ru</a>
            </p>
            <p className="text-xs text-gray-500 mt-2">
              Ответ в течение 3 рабочих дней. Все изменения в соглашении публикуются с уведомлением за 7 дней.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

